import { supabase } from '../supabase-client.ts';

export const getBackendAuthHeaders = async (headers = {}) => {
  const nextHeaders = { ...headers };
  const { data } = supabase ? await supabase.auth.getSession() : { data: null };
  const token = data?.session?.access_token || localStorage.getItem('token');

  if (token) {
    nextHeaders.Authorization = `Bearer ${token}`;
  }

  return nextHeaders;
};
